export const ADD_CORPORATE_BILLING_MASTER_UPLOAD = 'ADD_CORPORATE_BILLING_MASTER_UPLOAD'
export const ADD_CORPORATE_BILLING_MASTER_UPLOAD_FAILURE = 'ADD_CORPORATE_BILLING_MASTER_UPLOAD_FAILURE'
export const ADD_CORPORATE_BILLING_MASTER_UPLOAD_SUCCESS = 'ADD_CORPORATE_BILLING_MASTER_UPLOAD_SUCCESS'
export const ADD_CORPORATE_BILLING_MASTER_UPLOAD_FAILURE_FILE = 'ADD_CORPORATE_BILLING_MASTER_UPLOAD_FAILURE_FILE'

export const addCorporateBillingMasterUpload = (data) => {
    return {
        type: ADD_CORPORATE_BILLING_MASTER_UPLOAD,
        data
    }
}

export const addCorporateBillingMasterUploadFailure  = (data) => {
    return {
        type: ADD_CORPORATE_BILLING_MASTER_UPLOAD_FAILURE,
        data
    }
}

export const addCorporateBillingMasterUploadFailureFile = (data) => {
    return {
        type: ADD_CORPORATE_BILLING_MASTER_UPLOAD_FAILURE_FILE,
        data
    }
}

export const addCorporateBillingMasterUploadSuccess = (data) => {
    return {
        type: ADD_CORPORATE_BILLING_MASTER_UPLOAD_SUCCESS,
        data
    }
}

export const CORPORATE_BILLING_MASTER_TEMPLATE_REQUEST = 'CORPORATE_BILLING_MASTER_TEMPLATE_REQUEST';
export const CORPORATE_BILLING_MASTER_TEMPLATE_SUCCESS = 'CORPORATE_BILLING_MASTER_TEMPLATE_SUCCESS';
export const CORPORATE_BILLING_MASTER_TEMPLATE_FAILURE = 'CORPORATE_BILLING_MASTER_TEMPLATE_FAILURE';

export const corporateBillingMasterTemplateRequest = () => {
    return {
        type: CORPORATE_BILLING_MASTER_TEMPLATE_REQUEST,
    }
}

export const corporateBillingMasterTemplateSuccess = (data) => {
    return {
        type: CORPORATE_BILLING_MASTER_TEMPLATE_SUCCESS,
        data
    }
}

export const corporateBillingMasterTemplateFailure = (data) => {
    return {
        type: CORPORATE_BILLING_MASTER_TEMPLATE_FAILURE,
        data
    }
}


export const CORPORATE_BILLING_MASTER_DATA_EXCEL_SUCCESS = 'CORPORATE_BILLING_MASTER_DATA_EXCEL_SUCCESS';
export const CORPORATE_BILLING_MASTER_DATA_EXCEL_FAILURE = 'CORPORATE_BILLING_MASTER_DATA_EXCEL_FAILURE';
export const CORPORATE_BILLING_MASTER_DATA_EXCEL_REQUEST = 'CORPORATE_BILLING_MASTER_DATA_EXCEL_REQUEST';

export const corporateBillingMasterDataExcelRequest = () => {
    return {
        type: CORPORATE_BILLING_MASTER_DATA_EXCEL_REQUEST,
    }
}

export const corporateBillingMasterDataExcelSuccess = (data) => {
    return {
        type: CORPORATE_BILLING_MASTER_DATA_EXCEL_SUCCESS,
        data
    }
}

export const corporateBillingMasterDataExcelFailure = (data) => {
    return {
        type: CORPORATE_BILLING_MASTER_DATA_EXCEL_FAILURE,
        data
    }
}
